
export const CaseStatusLabel = {
  1: 'New Case',
  2: 'In Planning',
  3: 'Ready for QA',
  4: 'Need More Info',
  5: 'Case Updated by Ortho',
  6: 'Rejected By QA',
  7: 'Pending Ortho Check',
  8: 'Need Modifications',
  9: 'Pending Step Files',
  10: 'Pending Container Files',
  11: 'Stl Files Ready',
  12: 'Container Files Ready',
  13: 'Need Stl File Modifications',
  14: 'Need Container File Modifications',
  15: 'Approve Plan',
  // 16: 'Direct Printing Files Ready',
  // 17: 'Need Direct Printing Files Modifications',
  18: 'Case Completed',
  19: 'Case Canceled',
};